import {
    Switch,
    Route,
} from "react-router-dom";
import { UserPage } from "./pages/User";
import { LandingMain } from "./static/LandingMain";

const IgApp = () => {

    return (
        <div>
            <Switch>
                <Route exact path="/stapp/home">
                    <LandingMain />
                </Route>
                <Route exact path="/stapp/register">
                    <LandingMain />
                </Route>
                <Route path="/:userName">
                    <UserPage />
                </Route>
                <Route exact path="/">
                    <LandingMain />
                </Route>
            </Switch>
        </div>
    )
}

export default IgApp